import {Reducer} from 'redux'
import type {UserAction, UserState} from '../../types/types'

const initialUserState: UserState = {
  id: 0,
  email: '',
  displayName: '',
  permission: 0,
  token: '',
};

const userReducer: Reducer<UserState, UserAction> = function(state = initialUserState, action) {
  if(action.type === 'USER_UPDATE') {
    const {user, token} = action;
    return (user || token) ? {...state, ...user, token} : initialUserState;
  } else {
    return state;
  }
};

export default userReducer;
